import type { DocumentStructureFolderItem, Tables } from "../types";

/**
 * This function counts the number of folders and files in a document structure folder item.
 * It recursively traverses the items in the folder and counts how many folders and files are present
 * @param documentStructure
 * @returns
 */
export function getDocumentStructureFolderItemsCount<T extends { file: Tables<"files"> }>(
	documentStructure: DocumentStructureFolderItem<T>,
): { folders: number; files: number } {
	let folders = 0;
	let files = 0;

	function countItems(items: DocumentStructureFolderItem<T>["items"]) {
		for (const item of items) {
			if (item.type === "folder") {
				folders++;
				countItems(item.items);
			} else if (item.type === "file") {
				files++;
			}
		}
	}

	countItems(documentStructure.items);

	return {
		folders,
		files,
	};
}
